import { Stethoscope, AlertCircle } from "lucide-react"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"

interface ClinicalInfoCardProps {
  info: {
    allergies: string[]
    mainDiagnosis: string
    secondaryDiagnosis: string
  }
}

export function ClinicalInfoCard({ info }: ClinicalInfoCardProps) {
  return (
    <Card className="rounded-xl shadow-sm border">
      <CardHeader className="pt-2 pb-6">
        <CardTitle className="text-sm font-semibold flex items-center gap-2">
          <Stethoscope className="h-4 w-4 text-teal-600" />
          Clinical Information
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 pt-0">
        <div>
          <div className="text-xs text-muted-foreground mb-2">Allergies</div>
          <div className="flex flex-wrap gap-2">
            {info.allergies.map((allergy, i) => (
              <Badge 
                key={i} 
                variant="destructive" 
                className="rounded-full px-2 py-0.5 font-normal text-xs flex items-center gap-1"
              >
                <AlertCircle className="h-3 w-3 fill-current" />
                {allergy}
              </Badge>
            ))}
            {info.allergies.length === 0 && (
              <span className="text-xs text-muted-foreground">No known allergies</span>
            )}
          </div>
        </div>

        <div>
          <div className="text-xs text-muted-foreground">Main Diagnosis</div>
          <div className="text-sm font-medium mt-1">{info.mainDiagnosis}</div>
        </div>

        <div>
          <div className="text-xs text-muted-foreground">Secondary Diagnosis</div>
          <div className="text-sm font-medium mt-1">{info.secondaryDiagnosis}</div>
        </div>
      </CardContent>
    </Card>
  )
}
